import { MerchantSetupProductSchema } from "@redotech/redo-onboarding-db-schema";
import * as z from "zod";

/**
 * Fire-and-forget visit recording. Returns null on success — callers
 * should not block the navigation that triggered them.
 */
export const recordMerchantSetupTaskVisited = {
  name: "recordMerchantSetupTaskVisited" as const,
  input: z.object({
    product: MerchantSetupProductSchema,
    taskId: z.string().min(1).max(128),
  }),
  output: z.null(),
};
